import { ref } from 'vue';

const avatarRefreshKey = ref(0);
const isRefreshing = ref(false);

export const useAvatarRefresh = () => {
    const refreshAvatar = () => {
        isRefreshing.value = true;
        
        
        // Show loading for 5 seconds, then allow the new avatar to display
        setTimeout(() => {
            isRefreshing.value = false;
            avatarRefreshKey.value++;
        }, 2500);
    };

    const setRefreshing = () => {
        isRefreshing.value = true;
    };

    const getAvatarKey = () => avatarRefreshKey.value;

    return {
        refreshAvatar,
        setRefreshing,
        getAvatarKey,
        avatarRefreshKey: readonly(avatarRefreshKey),
        isRefreshing: isRefreshing
    };
};
